export const tableOption = {
  card: false,
  page: true,
  border: true,
  align: 'center',
  // searchSpan:20,
  emptyBtn: true,
  menuTitle:'活动内容',
  // header: false, //表格头部中间菜单
  refreshBtn:false,//刷新按钮
  searchShowBtn:false,//搜索栏目折叠显隐按钮
  menu: true,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  // searchSpan: 8,
  searchMenuSpan: 4,
  searchMenuPosition: 'right', //v2.7.9+
  menuWidth: 250,
  searchLabelWidth: 100,
  searchIcon: false,
  emptyText: '',
  column: [{
    label: '活动编号',
    prop: 'id',
    searchLabelWidth: 150,
    slot: true,
  },{
    label: '发布时间',
    prop: 'startTime',
    search: false,
    slot: true
  }, {
    label: '来源ID',
    prop: 'sourceId',
    searchLabelWidth: 60,
    search: true,
    searchSpan:4
  },{
    label: '轻任务订单号',
    prop: 'orderId',
    width: 180,
    search: true,
    searchSpan:6
  }, {
    label: '发布人',
    prop: 'createId',
  },{
    label: '触发方式',
    prop: 'autoType',
    dicData: [{
      label:'自动触发',
      value:'y'
    },{
      label:'手动触发',
      value:'n'
    }],
  },{
    label: '费用',
    prop: 'cost',
    slot: true,
    search: false
  },{
    label: '成本分配',
    slot: true,
    prop: 'amount',
    width: 200,
    search: false
  },
    {
      label: '活动状态',
      prop: 'status',
      dicData:[],
      type: 'select',
      search: true,
      searchSpan:5//搜索框宽度
    },
  ]
}

export const globalOption ={
  card: false,
  page: true,
  border: true,
  align: 'center',
  searchSpan: 20,
  emptyBtn: true,
  menuTitle:'查看配置',
  // header: false, //表格头部中间菜单
  refreshBtn:false,//刷新按钮
  searchShowBtn:false,//搜索栏目折叠显隐按钮
  menu: true,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  // searchSpan: 8,
  searchMenuSpan: 5,
  searchMenuPosition: 'right', //v2.7.9+
  menuWidth: 230,
  searchLabelWidth: 80,
  searchIcon: false,
  emptyText: '',
  column: [{
    label: '活动编号',
    prop: 'id',
    searchLabelWidth: 150,
  },{
    label: '开始时间',
    prop: 'startTime',
    type:'datetime',
    searchSpan:7,
    searchRange:true,
    search: true,
  }, {
    label: '截止时间',
    prop: 'endTime',
    type:'datetime',
    searchSpan:7,
    searchRange:true,
    search: true,
  }, {
    label: '发布人',
    prop: 'createId',
    search: false,
  },{
    label: '活动方案',
    prop: 'planType',
    dicData: [{
      label:'转盘奖励',
      value:'5'
    },{
      label:'天降惊喜',
      value:'6'
    },{
      label:'转盘奖励 天降惊喜',
      value:'6,5'
    },{
      label:'转盘奖励 天降惊喜',
      value:'5,6'
    }],
  },
    {
      label: '活动状态',
      prop: 'status',
      dicData:[],
      type: 'select',
      // hide: true,
      search: true,
      searchSpan:5//搜索框宽度
    },
  ]
}

export const globalOption2 ={
  card: false,
  page: true,
  border: true,
  align: 'center',
  // searchSpan:20,
  emptyBtn: true,
  menuTitle:'查看配置',
  // header: false, //表格头部中间菜单
  refreshBtn:false,//刷新按钮
  searchShowBtn:false,//搜索栏目折叠显隐按钮
  menu: true,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  // searchSpan: 8,
  searchMenuSpan: 5,
  searchMenuPosition: 'right', //v2.7.9+
  menuWidth: 200,
  searchLabelWidth: 80,
  searchIcon: false,
  emptyText: '',
  column: [{
    label: '活动编号',
    prop: 'id',
    searchLabelWidth: 150,
  },{
    label: '发布时间',
    prop: 'publishTime',
    type:'datetime',
    searchSpan:7,
    searchRange:true,
    search: true,
  }, {
    label: '截止时间',
    prop: 'endTime',
    type:'datetime',
    searchSpan:7,
    searchRange:true,
    search: true,
  }, {
    label: '发布人',
    prop: 'createId',
    search: false,
  },{
    label: '费用',
    prop: 'cost',
    slot: true,
    search: false
  },
    {
      label: '活动状态',
      prop: 'status',
      dicData:[],
      type: 'select',
      search: true,
      searchSpan:5//搜索框宽度
    },
  ]
}

export const OrderOption = {
  border: true,
  searchSpan:10,//搜索框宽度
  // selection: true,
  // rowKey:'orderId',//分页时候保留上一页的勾选状态实现唯一性指定字段
  // reserveSelection:true,//分页时候保留上一页的勾选状态实现
  maxHeight:500,
  searchMenuSpan:6,//搜索栏按钮宽度
  delBtn:false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: true,
  // showClomnuBtn: false,
  searchSize: 'mini',
  menu:false,
  addBtn: false,
  editBtn: false,
  viewBtn: false,
  header:false,
  column: [{
    label: '订单号',
    prop: 'orderId',
    slot: true,
    search: true,
  }, {
      label: '客户名称',
      prop: 'custName',
      editDisplay: false,
    },
    {
      label: '来源ID',
      prop: 'sourceId',
      editDisplay: false,
    },
    {
    label: 'PM',
    editDisplay: false,
    prop: 'pmName',
  }, {
    label: '要求完成时间',
    sortable: true,
    editDisplay: false,
    prop: 'limitTime',
    slot: true
  } ]
}

export const orderViewOption = {
  border: true,
  showHeader:true,//是否展示列名
  searchShow: false,
  // searchMenuSpan:4,
  delBtn:false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  menu:false,
  addBtn: false,
  editBtn: false,
  viewBtn: false,
  header:false,
  // selection: true,
  reserveSelection:true,
  props: {
    label: 'label',
    value: 'value'
  },
  column: [{
    label: '订单号',
    prop: 'orderId',
  },
  {
    label: '客户名称',
    prop: 'custName',
    editDisplay: false,
    row: true,
  }, {
      label: '来源ID',
      prop: 'sourceId',
      editDisplay: false,
      row: true,
    },
    {
    label: 'PM',
    width: 70,
    editDisplay: false,
    prop: 'pmName',
    row: true,
  }, {
    label: '要求完成时间',
    editDisplay: false,
    prop: 'limitTime',
    row: true,
    slot: true
  } ]
}

export const planOption = {
  border: true,
  showHeader:true,//是否展示列名
  searchShow: false,
  delBtn:false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  menu:false,
  addBtn: false,
  editBtn: false,
  viewBtn: false,
  header:false,
  props: {
    label: 'label',
    value: 'value'
  },
  column: [{
    label: '奖励类型',
    prop: 'code',
    dicData: [{
      label:'一等奖',
      value:1
    },{
      label:'二等奖',
      value:2
    },{
      label:'三等奖',
      value:3
    },{
      label:'四等奖',
      value:4
    },{
      label:'五等奖',
      value:5
    },{
      label:'六等奖',
      value:6
    }],
  },
    {
      label: '奖励金额',
      prop: 'amt',
    }, {
      label: '奖励翼币',
      prop: 'coin',
    },
    {
      label: '翼卡',
      prop: 'cardName',
    }, {
      label: '获奖时间',
      prop: 'createTime',
      row: true,
      slot: true
    }, {
      label: '译员昵称',
      prop: 'trId',
    } ]
}

export const planOption2 = {
  border: true,
  showHeader:true,//是否展示列名
  searchShow: false,
  delBtn:false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  menu:false,
  addBtn: false,
  editBtn: false,
  viewBtn: false,
  header:false,
  props: {
    label: 'label',
    value: 'value'
  },
  column: [{
    label: '译员昵称',
    prop: 'trId',
  },
    {
      label: '奖励现金',
      prop: 'amt',
    }, {
      label: '奖励翼币',
      prop: 'coin',
    },
    {
      label: '翼卡',
      prop: 'cardName',
    }, {
      label: '获奖时间',
      prop: 'createTime',
      row: true,
      slot: true
    } ]
}
